import {useTranslation} from 'react-i18next';
import {useRegistrationStep} from './useRegistrationStep';

type Props = {
  suffix?: string;
};

function RegistrationStepSubtitle({suffix}: Props) {
  const {t} = useTranslation();
  const stepState = useRegistrationStep();

  if (!stepState) return suffix ? <>{suffix}</> : null;

  const step = t('step_of_steps', {
    step: stepState.step,
    steps: stepState.totalSteps,
  });

  return <>{suffix ? `${step} · ${suffix}` : step}</>;
}

export {RegistrationStepSubtitle};
